import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import StepperField from 'components/StepperField';

import IntervalOemDefault from './components/IntervalOemDefault';
import UnitToggle from './components/UnitToggle';
import { INPUT_MAX, INPUT_MIN, INPUT_STEP, TEST_ID } from './constants';
import type { FunctionComponent, IntervalUnit, Props } from './types';

import styles from './styles.module.scss';

const IntervalConfigRow: FunctionComponent<Props> = ({
    availableUnits,
    canReset,
    className = '',
    isEditable,
    label,
    oemLabel,
    onChange,
    onReset,
    onUnitChange,
    part,
    resetLabel,
    testId = TEST_ID,
    unit,
    unitLabels,
    unitSuffix,
    value
}) => {
    const handleChange = ({ value: nextValue }: { value: number }) =>
        onChange({ part, value: nextValue });

    const handleSelectUnit = ({ unit: nextUnit }: { unit: IntervalUnit }) =>
        onUnitChange({ part, unit: nextUnit });

    const handleReset = () => onReset({ part });

    const isUnitSelectable = isEditable && availableUnits.length > 1;

    return (
        <HorizontalContainer className={`${styles.intervalConfigRow} ${className}`} testId={testId}>
            <StepperField
                className={styles.stepper}
                disabled={!isEditable}
                label={label}
                max={INPUT_MAX}
                min={INPUT_MIN}
                onChange={handleChange}
                step={INPUT_STEP}
                value={value}
            />

            {isUnitSelectable ? (
                <UnitToggle
                    onSelect={handleSelectUnit}
                    options={availableUnits}
                    selectedUnit={unit}
                    unitLabels={unitLabels}
                />
            ) : (
                <Wrapper className={styles.unitSuffix}>{unitSuffix}</Wrapper>
            )}

            <IntervalOemDefault
                canReset={canReset && isEditable}
                oemLabel={oemLabel}
                onReset={handleReset}
                resetLabel={resetLabel}
            />
        </HorizontalContainer>
    );
};

export default IntervalConfigRow;
